// @flow
import PropTypes from 'prop-types'
import {
  compose,
  branch,
  renderNothing,
  withProps,
  setPropTypes
} from 'recompose'
import {
  isAuctionClosed,
  isAuctionLive
  // isAuctionPending
} from '../auction/utils'
import { t } from '../../core/i18n'
import ActionBoxItem from '../../ui/boxes/action-box-item'

const withPropTypes = setPropTypes({
  item: PropTypes.object.isRequired,
  className: PropTypes.string,
  itemCountdownText: PropTypes.string.isRequired
})

const withPropsFormated = withProps(props => {
  const { item } = props
  if (!item.auction) return
  return {
    auction: item.auction,
    hasBidButton: isAuctionLive(item.auction),
    hasSaveButton: /* isAuctionPending(item.auction) */ false
  }
})

const withTranslations = withProps(props => {
  const { item } = props
  return {
    bidLabelText: t(
      `item.bids.${item.currentBidAmount ? 'current' : 'initial'}`
    ),
    currencyIconText: t('currency.dollarIcon')
  }
})

const ActionBoxEnhancer = compose(
  branch(({ item }) => item && isAuctionClosed(item.auction), renderNothing),
  withPropsFormated,
  withTranslations,
  withPropTypes
)

export default ActionBoxEnhancer(ActionBoxItem)



// WEBPACK FOOTER //
// ./src/services/item/ActionBox.js